import { render, staticRenderFns } from "./RecommendItem.vue?vue&type=template&id=720afbb8&scoped=true"
import script from "./RecommendItem.vue?vue&type=script&lang=js"
export * from "./RecommendItem.vue?vue&type=script&lang=js"
import style0 from "./RecommendItem.vue?vue&type=style&index=0&id=720afbb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720afbb8",
  null
  
)

export default component.exports